import { useEffect } from "react";

type SEO = {
  title?: string;
  description?: string;
  canonical?: string;
  keywords?: string;
  robots?: string; // "index, follow" vb.
  ogImage?: string;
  ogType?: string; // "website", "article"...
};

function upsertMeta(attr: { name?: string; property?: string }, content: string) {
  const selector = attr.name ? `meta[name="${attr.name}"]`
                             : `meta[property="${attr.property}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    if (attr.name) el.setAttribute("name", attr.name);
    if (attr.property) el.setAttribute("property", attr.property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO({
  title,
  description,
  canonical,
  keywords,
  robots = "index, follow",
  ogImage,
  ogType = "website",
}: SEO) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta({ name: "description" }, description);
    if (keywords) upsertMeta({ name: "keywords" }, keywords);
    if (robots) upsertMeta({ name: "robots" }, robots);

    // canonical
    if (canonical) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    // Open Graph (sosyal önizleme)
    if (title) upsertMeta({ property: "og:title" }, title);
    if (description) upsertMeta({ property: "og:description" }, description);
    upsertMeta({ property: "og:type" }, ogType);
    if (canonical) upsertMeta({ property: "og:url" }, canonical);
    if (ogImage) upsertMeta({ property: "og:image" }, ogImage);
  }, [title, description, canonical, keywords, robots, ogImage, ogType]);
}
